<template>
  <v-dialog v-model="dialog" :width="width">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="border-btn mr-2 align-center justify-center d-flex"
        width="120"
        height="30"
      >
        <img src="/static/btn/edit.png" class="mr-1" />
        <span class="border-text ">직접입력</span>
      </v-btn>
    </template>
    <v-card :width="complete ? 380 : 1500">
      <v-card-title class="back justify-start align-center">
        <h4>신규 발주 등록</h4>
        <v-spacer />
        <v-icon @click="dialog = !dialog" class="ma-0 pa-0 " color="white"
          >mdi-close</v-icon
        >
      </v-card-title>
      <div v-if="!complete" class="mt-3">
        <v-card-text class="pt-5">
          <v-row class="pl-4 align-center">
            <h5>{{ "현장명 : " + constructionName.constructionName }}</h5>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-row class="pl-5 pt-1">
            발주 입력한 데이터가 맞는지 마지막으로 확인해 주세요.
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-simple-table class="border-747474">
            <thead>
              <tr class="back-556C96">
                <th
                  rowspan="2"
                  class="border-right-white text-center color-white"
                >
                  발주차수
                </th>
                <th
                  rowspan="2"
                  class="text-center border-right-white color-white"
                >
                  부위
                </th>
                <th
                  :colspan="materialList.length"
                  class="border-right-white  text-center color-white"
                >
                  규격(단위:TON)
                </th>
                <th rowspan="2" class=" text-center color-white">발주수량</th>
              </tr>
              <tr class="back-556C96">
                <th
                  v-for="list in materialList"
                  :key="list.rebar_id"
                  class="border-right-white border-top-white text-center color-white"
                >
                  {{ list.rebar_name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="border-right border-top text-center">
                  <input v-model="orderName" class="border-aaaaaa  pa-0" />
                </td>
                <td class="border-top border-right text-center">
                  <input v-model="partName" class="border-aaaaaa  pa-0" />
                </td>
                <td
                  v-for="material in materialList"
                  :key="material.rebar_name"
                  class="border-top border-right text-center"
                >
                  <input
                    v-model.number="material.value"
                    type="number"
                    class="border-aaaaaa  pa-0"
                    @change="sum"
                  />
                </td>
                <td class="border-top text-center">{{ materialSum }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions class="justify-center d-flex pa-3">
          <div class="pl-5">
            <v-btn
              color="#739EEC"
              class="color-white default-btn-text mr-3"
              width="150"
              height="40"
              @click="insertOrderData"
            >
              확인
            </v-btn>
          </div>
        </v-card-actions>
      </div>
      <div v-if="complete">
        <v-card-text class="pt-4  justify-center d-flex">
          <h3 class="font-16">
            {{ "현장명 : " + constructionName.constructionName }}
          </h3>
        </v-card-text>
        <v-card-text class="pt-4 justify-center d-flex">
          <h5 class="font-14">{{ returnState }}</h5>
        </v-card-text>
        <div class="pa-5 justify-center d-flex ">
          <v-btn
            rounded
            width="140"
            height="38"
            color="#3F557D"
            class="color-white"
            @click="dialog = !dialog"
          >
            확인
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import OrderApi from "@/api/OrderService";
import Commonality from "@/mixin/Commonality";
export default {
  mixins: [Commonality],
  data: function() {
    return {
      dialog: false,
      orderName: "",
      partName: "",
      width: 1000,
      complete: false,
      returnState: "",
      materialSum: 0,
    };
  },
  created() {
    for (let i = 0; i < this.materialList.length; i++) {
      this.materialList[i].value = 0;
    }
    this.sum();
  },
  watch: {
    dialog(val) {
      if (!val) {
        for (let i = 0; i < this.materialList.length; i++) {
          this.materialList[i].value = 0;
        }
        this.sum();
        this.partName = "";
        this.orderName = "";
        this.complete = false;
        this.width = 1000;
      }
    },
  },

  methods: {
    sum() {
      let sum = 0;
      for (let i = 0; i < this.materialList.length; i++) {
        sum += Number(this.materialList[i].value);
      }
      this.materialSum = this.mathRound(sum);
    },
    async insertOrderData() {
      if (this.orderName.length < 2 && this.partName.length < 2) {
        this.$bus.$emit(
          "dialog",
          "발주차수 및 부위를 두 글자 이상 입력해주세요."
        );
        return;
      }
      let data = {
        orderData: [
          {
            constructionId: this.constructionId,
            orderName: this.orderName,
            partName: this.partName,
            rebarList: [],
          },
        ],
      };

      for (let i = 0; i < this.materialList.length; i++) {
        data.orderData[0].rebarList[i] = this.materialList[i].value
          ? Number(this.materialList[i].value)
          : 0;
      }
      let returnData = await OrderApi.orderCreate(data);
      if (returnData.data.success == "ok")
        this.returnState = "발주데이터 입력이 완료 되었습니다.";
      else
        this.returnState = `${returnData.data.reason} 입니다. 확인후 다시 시도 해주세요.`;
      this.$bus.$emit("orderNavigationDuplicated");
      this.width = 380;
      this.complete = true;
    },
  },
};
</script>

<style scoped>
.font-16 {
  font-size: 16px;
}
.font-14 {
  font-size: 14px;
}
.back {
  background: #556c96 !important;
}

.border-747474 {
  border: thin solid #747474;
}

input {
  width: 50px;
  text-align: center;
}

.border-left {
  border-left: thin solid #747474;
}
.border-right {
  border-right: thin solid #747474;
}
.border-top {
  border-top: thin solid #747474;
}
.border-bottom {
  border-bottom: thin solid #747474;
}

.border-bottom-white {
  border-bottom: thin solid white;
}
h4 {
  color: white;
}
h5 {
  font-size: 15px;
}
</style>
